export default "__VITE_ASSET__DQW4iZXt__"